/**
 * @module router/modules/partner
 * @description 파트너 도메인 라우트 모듈 — 파트너 등록/배정 관리,
 * 유저 그룹 고객사 배정, 소속 파트너 고객사 배정, 자동 배정 관리 페이지 경로를 정의합니다.
 */
const routes = [
  {
    path: '/partner-alloc-management',
    name: '파트너등록 관리',
    component: () => import(/* webpackChunkName: "partnerAllocManagement" */ '../../views/partner/PartnerAllocManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  // SURINP-191 S7-2-C (2026-04-29): /partner-register 라우트 제거.
  // 기존 popup/PartnerRegister.vue + window.open 패턴 → PartnerRegisterModal 컴포넌트로 통합.
  {
    path: '/user-group-partner-allocation-management',
    name: '유저 그룹 고객사 배정 관리',
    component: () => import('../../views/partner/UserGroupPartnerAllocationManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  // SURINP-191 S7-2-D (2026-04-29): /user-group-partner-allocation-register 라우트 제거.
  // 기존 popup/UserGroupPartnerAllocationRegister.vue + window.open 패턴 → UserGroupPartnerAllocationRegisterModal 컴포넌트로 통합.
  {
    path: '/staff-team-partner-relation-management',
    name: '소속파트너 소속 고객사 배정 관리',
    component: () => import('../../views/partner/StaffTeamPartnerRelationManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  // SURINP-191 S7-2-A (2026-04-29): /staff-team-partner-relation-register 라우트 제거.
  // 기존 popup/StaffTeamPartnerRelationRegister.vue + window.open 패턴 → StaffTeamPartnerRelationRegisterModal 컴포넌트로 통합.
  {
    path: '/auto-assign-management',
    name: '자동 배정 관리',
    component: () => import('../../views/partner/AutoAssignManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, partnerSelect: true }
  },
  {
    path: '/user-group-auto-assign-management',
    name: '유저 그룹 자동 배정 관리',
    component: () => import('../../views/partner/UserGroupAutoAssignManagement.vue'),
    meta: { platform: 'web', menuYn: true, authorization: true, partnerSelect: true }
  }
]

export default routes
